import { render, staticRenderFns } from "./UserManagementDropdown.vue?vue&type=template&id=6da6c751&scoped=true"
import script from "./UserManagementDropdown.vue?vue&type=script&lang=js"
export * from "./UserManagementDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da6c751",
  null
  
)

export default component.exports